import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpGridColumn } from './op-grid-column'
import { OpGridOption } from './op-grid-option'
import { OpGridRow } from './op-grid-row'


export class OpGridControl extends OpDashboardControl {
    //Properties
    public static referenceValueArray: string = "ReferenceValueArray"
    public static rowColor: string = "RowColor"
    public static rowTooltip: string = "RowTooltip"
    public static rowTooltipParams: string = "RowTooltipParams"
    public static cellColor: string = "CellColor"

    public columns: OpGridColumn[]
    public dataSource: OpGridRow[]
    public options: OpGridOption[]
    public headerTextAlign: Enums.TextAlign
    public contextMenuEnabled: boolean
    public shortDetailsEnabled: boolean
    //Properties end

    //NavigationProperties
    public textHeader: OpDescr
    //NavigationProperties end

    constructor(opObj: any) {
        super(opObj)
        if (opObj) {
            this.contextMenuEnabled = opObj.ContextMenuEnabled
            this.shortDetailsEnabled = opObj.ShortDetailsEnabled
            this.headerTextAlign = opObj.HeaderTextAlign
            if (opObj.Columns)
                this.columns = opObj.Columns.map(data => new OpGridColumn(data))
            if (opObj.DataSource)
                this.dataSource = opObj.DataSource.map(data => new OpGridRow(data))
            if (opObj.Options)
                this.options = opObj.Options.map(data => new OpGridOption(data))
        }
        if (!this.columns)
            this.columns = []
        if (!this.dataSource)
            this.dataSource = []
        if (!this.options)
            this.options = []
    }
}